import axios from 'axios';
import { useEffect, useState } from 'react';
import OpenandCloseModal from './OpenandCloseModal';
import { LiaStarSolid } from 'react-icons/lia';
import { MdAccountCircle } from 'react-icons/md';
import {
  formatAmount,
  formatDateStrToDate,
  formatRating,
  getToken,
} from '../utils';

function BuyOfferData() {
  const [buyOfferData, setBuyOfferData] = useState([]);

  const { token: userToken } = getToken();

  const {
    handleOpenandCloseModal,
    setOfferDetails,
    offerDetails,
    setCxId,
    cxId,
    openModal,
  } = OpenandCloseModal();

  useEffect(() => {
    const getBuyOffers = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/cx-transaction/specific-cxs`,
          {
            transaction_type_id: 1,
            transaction_status_id: 1,
          },
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );

        setBuyOfferData(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    getBuyOffers();
  }, [userToken]);

  // console.log({ buyOfferData });

  const buyOfferDataArray = buyOfferData?.map((buyOffers) => {
    return {
      date: `${formatDateStrToDate(buyOffers?.created_at)}`,

      // currency: (
      //   <div className="flex flex-row items-center gap-2 justify-center">
      //     <img
      //       className="w-5 h-[13px]"
      //       src={buyOffers?.quote_currency?.country.flag}
      //       alt="currency flag"
      //     />
      //     <p>{buyOffers?.quote_currency.name}</p>
      //   </div>
      // ),
      amount: (
        <div className='flex flex-row items-center gap-2 justify-center'>
          <img
            className='w-5 h-[13px]'
            src={buyOffers?.quote_currency?.country?.flag}
            alt='currency flag'
          />
          <p>
            {`${formatAmount(buyOffers?.amount * 1)} ${
              buyOffers?.quote_currency?.symbol
            }`}
          </p>
        </div>
      ),
      rate: ` ${formatAmount(buyOffers?.rate)}  ${
        buyOffers?.base_currency.symbol
      }`,
      payment: buyOffers?.transaction_method?.name,
      buyer_seller: (
        <div className='flex flex-row items-start gap-2'>
          <span className='text-4xl text-b-mc/70'>
            <MdAccountCircle />
          </span>
          <div className='flex flex-col justify-start text-left'>
            <p>{buyOffers?.unique_code}</p>
            <div className='flex flex-col gap- text-sm'>
              <p className='flex flex-row items-center gap-1 text-s-bk'>
                Rating: {formatRating(buyOffers?.user?.rating)}{' '}
                <span className='text-green-500 -m-1'>
                  <LiaStarSolid />
                </span>
              </p>{' '}
              {/* <p className="flex flex-row items-center gap-1 text-s-bk">
              Order: {data?.user.trx_stats?.completed}{" "}
              <span className="text-green-500 -m-1">{<BiTransfer />}</span>
            </p> */}
            </div>
          </div>
        </div>
      ),
      action: (
        <button
          className='text-p-wh px-4 py-1.5 rounded text-[10px] w-fit active:bg-t-bk hover:bg-green-600 bg-green-500'
          onClick={() => getCLickedRowId(buyOffers?.id)}
        >
          See details
        </button>
      ),
    };
  });

  const getCLickedRowId = (ids) => {
    setCxId(ids);
    for (let i = 0; i < buyOfferData.length; i++) {
      if (buyOfferData[i].id === ids) {
        setOfferDetails(buyOfferData[i]);
        handleOpenandCloseModal('offerdetails');
      }
    }
  };
  return {
    buyOfferDataArray,
    handleOpenandCloseModal,
    offerDetails,
    cxId,
    openModal,
  };
}

export default BuyOfferData;
